// Default no-poster workflow covers. The `-fpl` variants are the same artwork recolored so their
// background matches the FPL `bg` token (#2c2c2c) instead of Black92, so they blend with the migrated
// surface. Kept as separate assets so the flag-off path renders the original Black92 covers.
const DEFAULT_WORKFLOW_COVER = '/workflow-default-cover.png';
const DEFAULT_WORKFLOW_COVER_LIST = '/workflow-default-cover-list.png';
const DEFAULT_WORKFLOW_COVER_FPL = '/workflow-default-cover-fpl.png';
const DEFAULT_WORKFLOW_COVER_LIST_FPL = '/workflow-default-cover-list-fpl.png';

/** Pick the default cover for a no-poster workflow, swapping to the `bg`-token variant when fpl-migration is on. */
export function defaultWorkflowCover(isFplMigrationEnabled?: boolean, variant: 'card' | 'list' = 'card'): string {
  if (variant === 'list') {
    return isFplMigrationEnabled ? DEFAULT_WORKFLOW_COVER_LIST_FPL : DEFAULT_WORKFLOW_COVER_LIST;
  }
  return isFplMigrationEnabled ? DEFAULT_WORKFLOW_COVER_FPL : DEFAULT_WORKFLOW_COVER;
}
